import React, { useState, useEffect } from "react";
import axios from "axios";
//import Sidenav from "../components/Sidenav";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createEmployee,
  resetEmployeeCreate,
} from "../features/employee/employeeSlice";
import { createUser, resetUserCreate } from "../features/user/userSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { logout } from "../features/user/userSlice";

const CreateOfficeAgent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedImage, setSelectedImage] = useState(null); // For Image Preview

  const [officeAgentImage, setOfficeAgentImage] = useState("");
  const [officeAgentName, setOfficeAgentName] = useState("");
  const [NIDNumber, setNIDNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [officeAgentEmail, setOfficeAgentEmail] = useState("");
  const [agentCommission, setAgentCommission] = useState("");
  const [officeAgentSalary, setOfficeAgentSalary] = useState("");
  const [officeAgentLoan, setOfficeAgentLoan] = useState("");
  const [monthlyDeduction, setMonthlyDeduction] = useState("");
  const [officeAgentAddress, setOfficeAgentAddress] = useState("");

  const [agentUsername, setAgentUsername] = useState("");
  const [agentPassword, setAgentPassword] = useState("");

  const [openUserInfo, setOpenUserInfo] = useState(false);

  const { userInfo } = useSelector((state) => state.user);

  const {
    employee,
    isCreateLoading,
    isCreateError,
    isCreateSuccess,
    createErrorMessage,
  } = useSelector((state) => state.employee);

  const {
    user,
    isCreateLoading: isUserCreateLoading,
    isCreateError: isUserCreateError,
    isCreateSuccess: isUserCreateSuccess,
    createErrorMessage: createUserErrorMessage,
  } = useSelector((state) => state.user);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("createEmployee") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if ((isCreateSuccess && isUserCreateSuccess) || isCreateSuccess) {
      toast.success("Employee Created Successfully", {
        position: "top-center",
      });
      navigate("/OfficeAgentList");
    } else if (isCreateError || isUserCreateError) {
      toast.error(
        isCreateError && isUserCreateError
          ? "Something Went Wrong While Creating Employee or User!!"
          : isCreateError
          ? createErrorMessage
          : createUserErrorMessage,
        {
          position: "top-center",
        }
      );
    }
  }, [
    isCreateSuccess,
    isUserCreateSuccess,
    isCreateError,
    isUserCreateError,
    createErrorMessage,
    createUserErrorMessage,
    navigate,
    employee,
  ]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      agentUsername !== "" &&
      agentPassword !== "" &&
      officeAgentName !== "" &&
      NIDNumber !== "" &&
      phoneNumber !== ""
    ) {
      const employeeData = {
        image: officeAgentImage,
        fullName: officeAgentName,
        nid: NIDNumber,
        phone: phoneNumber,
        email: officeAgentEmail,
        commission: agentCommission,
        salary: officeAgentSalary,
        loan: officeAgentLoan,
        monthlyDeduction: monthlyDeduction,
        address: officeAgentAddress,
      };

      const userData = {
        userName: agentUsername,
        password: agentPassword,
      };

      dispatch(
        createEmployee({
          employeeData,
          userData,
        })
      );
    } else if (
      agentUsername === "" &&
      agentPassword === "" &&
      officeAgentName !== "" &&
      NIDNumber !== "" &&
      phoneNumber !== ""
    ) {
      const employeeData = {
        image: officeAgentImage,
        fullName: officeAgentName,
        nid: NIDNumber,
        phone: phoneNumber,
        email: officeAgentEmail,
        commission: agentCommission,
        salary: officeAgentSalary,
        loan: officeAgentLoan,
        monthlyDeduction: monthlyDeduction,
        address: officeAgentAddress,
      };

      const userData = null;

      dispatch(
        createEmployee({
          employeeData,
          userData,
        })
      );
    } else if (agentUsername !== "" && agentPassword === "") {
      toast.error("Please Fill Password Field", {
        position: "top-center",
      });
    } else if (agentUsername === "" && agentPassword !== "") {
      toast.error("Please Fill Username Field", {
        position: "top-center",
      });
    } else {
      toast.error("Something Went Wrong!! Please Try Again..", {
        position: "top-center",
      });
    }
  };

  // Office Agent Image Upload
  const uploadImageFileHandler = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    // if (file) {
    //   const reader = new FileReader()

    //   reader.onload = () => {
    //     setSelectedImage(reader.result)
    //   }

    //   reader.readAsDataURL(file)
    // }

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `/api/v1/upload${
          officeAgentImage ? `/${officeAgentImage.slice(8)}` : ""
        }`,
        formData,
        config
      );
      // officeAgentImage(data)
      setOfficeAgentImage(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetEmployeeCreate());
      dispatch(resetUserCreate());
    };
  }, [dispatch]);

  return (
    <Container fluid className="my-4">
      {/* <h2 style={{ fontWeight: "bold" }} className="mb-4 text-center">
        Create Employee
      </h2> */}
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="my-3 text-dark text-center fw-bold">
            Create <span style={{ color: "#5c91dc" }}>Employee</span>
          </h2>
        </Card>
      </Row>
      <>
        {isCreateLoading ? (
          <Loader />
        ) : (
          <Form onSubmit={submitHandler}>
            <Row>
              {/* Column for Upload Image  */}
              <Col sm={12} md={4} lg={3}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    className="text-black text-center p-3 fw-bold"
                    style={{ backgroundColor: "#74a2e3" }}
                    as="h5"
                  >
                    Upload Employee Image
                  </Card.Header>
                  <Card.Body className="text-center">
                    <Card.Img
                      cascade
                      className="img-fluid rounded"
                      src={
                        officeAgentImage !== ""
                          ? officeAgentImage
                          : "http://bootdey.com/img/Content/avatar/avatar7.png"
                      }
                      alt="Preview"
                      style={{ height: "20vh", borderRadius: "50%" }}
                    />
                    <div className="small font-italic text-muted mt-3">
                      JPG or PNG no larger than 5 MB
                    </div>
                    <Form.Group controlId="image 1">
                      <Form.Label className="my-3 text-black">
                        Upload Image
                      </Form.Label>
                      <Form.Control
                        //required
                        className="mb-3 rounded shadow-sm "
                        type="file"
                        id="image-file"
                        label="Employee Image"
                        controlId="EmployeeImage"
                        // accept="image/*"
                        onChange={uploadImageFileHandler}
                      ></Form.Control>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Col>

              {/* Column For Form Submit */}
              <Col sm={12} md={8} lg={9}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    className="text-black text-center p-3 fw-bold"
                    style={{ backgroundColor: "#74a2e3" }}
                    as="h5"
                  >
                    Employee Information
                  </Card.Header>
                  <Card.Body className="fw-bold">
                    <Row>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="Name">
                          <Form.Label style={{ color: "black" }}>
                            Full Name
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Full Name"
                            value={officeAgentName}
                            onChange={(e) => setOfficeAgentName(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="NIDNumber">
                          <Form.Label style={{ color: "black" }}>
                            NID Number
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder="Enter NID Number"
                            value={NIDNumber}
                            onChange={(e) => setNIDNumber(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="phoneNumber">
                          <Form.Label style={{ color: "black" }}>
                            Phone Number
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder="Enter Phone Number"
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="AgentEmail">
                          <Form.Label style={{ color: "black" }}>
                            Email
                          </Form.Label>
                          <Form.Control
                            //required
                            type="email"
                            placeholder="Enter Email"
                            value={officeAgentEmail}
                            onChange={(e) =>
                              setOfficeAgentEmail(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="AgentSalary">
                          <Form.Label style={{ color: "black" }}>
                            Salary
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder="Enter Salary Ammount"
                            value={officeAgentSalary}
                            onChange={(e) =>
                              setOfficeAgentSalary(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="commission">
                          <Form.Label style={{ color: "black" }}>
                            Commission
                          </Form.Label>
                          <Form.Control
                            //required
                            type="number"
                            placeholder="Commission Percentage"
                            value={agentCommission}
                            onChange={(e) => setAgentCommission(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="loan">
                          <Form.Label style={{ color: "black" }}>
                            Loan Taken
                          </Form.Label>
                          <Form.Control
                            //required
                            type="number"
                            placeholder="Loan Amount"
                            value={officeAgentLoan}
                            onChange={(e) => setOfficeAgentLoan(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="monthlyDeduction">
                          <Form.Label style={{ color: "black" }}>
                            Monthly Deduction
                          </Form.Label>
                          <Form.Control
                            //required
                            type="number"
                            placeholder="Monthly Deduction Amount"
                            value={monthlyDeduction}
                            onChange={(e) =>
                              setMonthlyDeduction(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={12} lg={12}>
                        <Form.Group controlId="AgentAddress">
                          <Form.Label style={{ color: "black" }}>
                            Address
                          </Form.Label>
                          <Form.Control
                            //required
                            type="textarea"
                            as="textarea"
                            rows={2}
                            placeholder="Enter Address"
                            value={officeAgentAddress}
                            onChange={(e) =>
                              setOfficeAgentAddress(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    {userInfo && userInfo.userType === "admin" ? (
                      <>
                        <Row className="px-3 mb-3 mt-4">
                          <Col>
                            <Button
                              variant="outline-primary"
                              className="rounded"
                              onClick={() => setOpenUserInfo(!openUserInfo)}
                            >
                              {openUserInfo ? "Close" : "Add Login Info"}
                            </Button>
                          </Col>
                        </Row>

                        {openUserInfo && (
                          <Card.Body>
                            <Row className="">
                              <Col sm={12} md={6} lg={6}>
                                <Form.Group controlId="agentUsername">
                                  <Form.Label style={{ color: "black" }}>
                                    Username
                                  </Form.Label>
                                  <Form.Control
                                    required={
                                      agentPassword !== "" ? true : false
                                    }
                                    type="text"
                                    placeholder="Enter Username"
                                    value={agentUsername}
                                    onChange={(e) =>
                                      setAgentUsername(e.target.value)
                                    }
                                  ></Form.Control>
                                </Form.Group>
                              </Col>
                              <Col sm={12} md={6} lg={6}>
                                <Form.Group controlId="agentPassword">
                                  <Form.Label style={{ color: "black" }}>
                                    Password
                                  </Form.Label>
                                  <Form.Control
                                    required={
                                      agentUsername !== "" ? true : false
                                    }
                                    type="text"
                                    placeholder="Enter Password"
                                    value={agentPassword}
                                    onChange={(e) =>
                                      setAgentPassword(e.target.value)
                                    }
                                  ></Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>
                          </Card.Body>
                        )}
                      </>
                    ) : null}

                    <Row className="px-4 mt-4 mb-3">
                      <Button
                        variant="outline-primary"
                        type="submit"
                        className="rounded"
                        // onClick={submitHandler}
                      >
                        Create Employee
                      </Button>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </>
    </Container>
  );
};

export default CreateOfficeAgent;
